import { module }from 'stereomodularjs';
import { html } from '../utils/environment'

/*
    USAGE :
    <button class="myElement" data-module="SetFocus" data-focus=".js-element"></button>
    data-focus : [scoped element ".myClass"] 
 */

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'setFocus'
        }
    }

    init() {
        let thisEl = this.el;
        if(thisEl.dataset.blurfocus){
            thisEl.addEventListener('blur', () => {
                document.querySelector(thisEl.getAttribute('data-focus')).focus();
            });
        }
    }

    setFocus(e) {
        let thisEl = this.el;
        // If Focus is needed (like search input), focus on element.
        if (thisEl.getAttribute('data-focus')) {
            document.activeElement.blur();
            document.querySelector(thisEl.getAttribute('data-focus')).focus();
            // console.log('focus sent to : '+thisEl.getAttribute('data-focus'));
        }
    }
    blurFocus(){

    }
}
